import { createSlice } from '@reduxjs/toolkit'

export const counterSlice = createSlice({
  name: 'userData',
  initialState: {
    tokens:{
        refresh: "",
        login: ""
    },
    firstContact: true,
    data: {
      profilePic: undefined,
      surname: undefined,
      onames: undefined,
      location:{
        region: undefined,
        country: undefined,
        zipStree: undefined
      },
      date_of_birth: undefined,
      gender: undefined,
      phone_number: undefined,
      employment_status: undefined
    }
  },
  reducers: {
    setTokens:(state, payload:{type: string, payload:{refresh: string, login: string}})=>{
        state.tokens=payload.payload
    },
    firstContactHappened:(state, payload: any|undefined)=>{
        state.firstContact = false;
        if(payload){
          state.data = payload.payload
        }
    }
  },
})

// Action creators are generated for each case reducer function
export const { setTokens, firstContactHappened } = counterSlice.actions

export default counterSlice.reducer